import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgEditFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m17.707 3.293 4 4a1 1 0 0 1 0 1.414L20 10.414V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h8.586l1.707-1.707a1 1 0 0 1 1.414 0ZM9 13.414l8-8L19.586 8l-8 8H9v-2.586Z", fill: color }));
};
export default factorySvgIcon(SvgEditFilled);
//# sourceMappingURL=SvgEditFilled.js.map